const Colors = {
  primary: '',
  grey: '#858585',
  darkGrey: '#555555',
  darkestGrey: '#2C2C2C',
  darkSlateBlue: '#3D3FA8',
  sandyBrown: '#A9A9A91A',
  midNightBlue: '#262758',
  aliceBlue: '#ECF4F9',
  silver: '#B7B7B7',
  whiteSmoke: '#ECECEC',
  slateBlue: '#4648C3',
  white: '#ffffff',
  gold: '#FFC933',
  lightSteelBlue: '#A0A4DF',
};

export default Colors;
